import { collection, getDocs, query, where } from "firebase/firestore";
import { firestore } from "../firebase";

/**
 * Fetches all documents from a named collection, optionally constrained to
 * the current user's own records when the caller is a "staff" role and a
 * staffField is provided. Mirrors the original inline fetchRows() helper in
 * Reports.js exactly, including the default staffField = ''.
 */
export async function fetchReportCollection(collectionName, { role, userId, staffField = "" } = {}) {
  const ref =
    role === "staff" && staffField
      ? query(collection(firestore, collectionName), where(staffField, "==", userId))
      : collection(firestore, collectionName);
  const snapshot = await getDocs(ref);
  return snapshot.docs.map((item) => ({ id: item.id, ...item.data() }));
}
